import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler
);

export const LineChart = ({ width, height, data }) => {
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      if (!data || !Array.isArray(data.xValues) || !Array.isArray(data.yValues)) {
        throw new Error("Invalid data: 'xValues' and 'yValues' must be arrays.");
      }

      const preparedData = {
        labels: data.xValues,
        datasets: data.yValues.map((series, index) => {
          if (!series.label || !Array.isArray(series.data)) {
            throw new Error(`Invalid dataset at index ${index}`);
          }

          return {
            label: series.label,
            data: series.data,
            fill: false,
            tension: 0.3,
            pointRadius: 4,
            pointHoverRadius: 6,
          };
        }),
      };

      setChartData(preparedData);
      setError(null);
    } catch (err) {
      console.error("LineChart Error:", err);
      setError("Unable to render chart. Please check the data format.");
    }
  }, [data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: { enabled: true },
    },
    scales: {
      x: {
        title: { display: true },
        grid: { display: true },
      },
      y: {
        beginAtZero: true,
        grid: { color: "#f1f1f1" },
      },
    },
  };

  return (
    <div style={{ width, height }}>
      {error ? (
        <div style={{ color: "red", padding: "10px" }}>{error + "Use Another favorite prompt to generate"}</div>
      ) : (
        chartData && <Line data={chartData} options={options} />
      )}
    </div>
  );
};
